window.UpImages = function () {
    var el = this;
    var usedImages;
    var lastName = '';
    var destId = 0;
    var destClassName = '';

    var distribution = 0;
    var newFiles = [];

    el.files = [];

    el.render = function () {
        var data = {
            files: []
        };
        for (var i in el.files) {
            var file = $.extend(true, {}, el.files[i]);
            file.is_used = usedImages.hasOwnProperty(file.filename) ? true : false;
            data.files.push(file);
        }

        var html = window.Mustache.render($('#uploaded-image-template').html(), data);
        $('.project-images').html(html);
        reInitDimensions();
    };

    function calculateUsedImages() {
        for (var i in el.workData.workareas) {
            var reversal = el.workData.workareas[i].format;
            for (var j in reversal.backgrounds) {
                var item = reversal.backgrounds[j];
                if (item !== null) {
                    el.setUsedImage(item.name);
                }
            }

            for (var j in reversal.images) {
                var item = reversal.images[j];
                if (item !== null) {
                    el.setUsedImage(item.name);
                }
            }

            if (!reversal.hasOwnProperty('calendar_grids')) {
                continue;
            }

            for (var j in reversal.calendar_grids) {
                var grid = reversal.calendar_grids[j];

                if (!grid.days.numbers.hasOwnProperty('items')) {
                    continue;
                }

                for (var k in grid.days.numbers.items) {
                    var number = grid.days.numbers.items[k];

                    for (var l in number.backgrounds) {
                        var background = number.backgrounds[l];
                        if (background !== null) {
                            el.setUsedImage(background.name);
                        }
                    }
                }
            }
        }
    }

    function reInitDimensions() {
        var height = 'auto';

        if (window.innerWidth >= 768) {
            height = window.innerHeight;
            $('#page-step-constructor > .navbar').each(function () {
                height -= $(this).outerHeight();
            });
        }

        $('.project-images').height(height);
    }

    el.init = function () {
        usedImages = {};
        calculateUsedImages();

        el.getImages(function () {
            el.render();
        });
    };

    el.reInitUsedImages = function () {
        usedImages = {};
        calculateUsedImages();
        el.render();
    };

    el.add = function (file) {
        var id = Object.keys(el.files).length;
        el.files[id] = file;

        newFiles.push(id);

        if (destId !== 0) {
            lastName = file.filename;
            el.drop(destClassName, el.selectWorkareaId, destId);
            destId = 0;
            destClassName = '';
        }
    };

    el.getImages = function (cb) {
        el.request.get(window.requestUrls.image.get, function (response) {
            el.files = response.filenames;
            cb();
        }, 'json');
    };

    el.onloadImage = function (image, className, workareaId, id, name, themeId, companyId) {
        var pos = {};
        switch (className) {
            case 'images':
                var cell = $.extend(true, {}, el.workData.workareas[workareaId].format.cells[id]);
                pos = {
                    x: parseInt(cell.x),
                    y: parseInt(cell.y),
                    width: parseInt(cell.width),
                    height: parseInt(cell.height)
                };
                break;
            case 'backgrounds':
                var format = el.workData.workareas[workareaId].format;
                pos = {
                    x: 0,
                    y: 0,
                    width: el.WORKAREA_WIDTH,
                    height: parseInt(el.WORKAREA_WIDTH * format.height / format.width)
                };
                break;
            default:
                return false;
        }



        pos = el.setImagePosition(image.width, image.height, pos);

        pos.name = name;
        pos.type = 'custom';
        pos.data_width = image.width;
        pos.data_height = image.height;

        if (typeof themeId !== "undefined") {
            pos.type = 'theme';
            pos.theme_id = themeId;
            pos.company_id = companyId;
        } else if (el._parent.hasOwnProperty('isTemplater')) {
            pos.type = 'template';
            pos.theme_id = window.bookSid;
        }

        updateData(el._parent.workData.workareas[workareaId].format, pos);

        function updateData(reversal, pos) {
            if (className === 'images' && reversal[className].hasOwnProperty(id) && reversal[className][id] !== null && reversal[className][id].hasOwnProperty('mask')) {
                pos.mask = reversal[className][id].mask;
                if (reversal[className][id].hasOwnProperty('company_id')) {
                    pos.company_id = reversal[className][id].company_id;
                }
            }

            if (reversal[className].hasOwnProperty(id) && reversal[className][id] !== null) {
                el.unsetUsedImage(reversal[className][id].name);
            }

            reversal[className][id] = pos;
        }

        el.history.add();
    };

    el.reinitImagePosition = function(workareaId, type, selectId) {
        var pos = {};
        var className;

        switch(type) {
            case 'cell':
                className = 'images';
                var cell = $.extend(true, {}, el.workData.workareas[workareaId].format.cells[selectId]);
                pos = {
                    x: parseInt(cell.x),
                    y: parseInt(cell.y),
                    width: parseInt(cell.width),
                    height: parseInt(cell.height)
                };
                break;
            case 'backgrounds':
                className = 'backgrounds';
                var format = el.workData.workareas[workareaId].format;
                pos = {
                    x: 0,
                    y: 0,
                    width: el.WORKAREA_WIDTH,
                    height: parseInt(el.WORKAREA_WIDTH * format.height / format.width)
                };
                break;
            default:
                return false;
        }

        var image = el._parent.workData.workareas[workareaId].format[className][selectId];
        var width = image.data_width;
        var height = image.data_height;
        var imagePos = $.extend(true, {}, pos);

        if (image.hasOwnProperty('rotate_angle') && parseInt(image.rotate_angle % 180) !== 0) {
            if (height / width > pos.width / pos.height) {
                imagePos.width = parseInt(pos.height);
                imagePos.height = Math.floor(imagePos.width / (width / height));
                imagePos.y = pos.y + Math.floor((pos.height - imagePos.height) / 2);
                imagePos.x = pos.x + Math.floor((pos.width - pos.height) / 2);
            } else {
                imagePos.height = parseInt(pos.width);
                imagePos.width = Math.floor(imagePos.height * (width / height));
                imagePos.x = pos.x + Math.floor((pos.width - imagePos.width) / 2);
                imagePos.y = pos.y + Math.floor((pos.height - pos.width) / 2);
            }

            image.x = imagePos.x;
            image.width = imagePos.width;
            image.y = imagePos.y;
            image.height = imagePos.height;
            image.rotate_x = parseInt(image.x + (image.width / 2));
            image.rotate_y = parseInt(image.y + (image.height / 2));

        } else {
            if (width / height > pos.width / pos.height) {
                var newWidth = Math.floor(width / (height / pos.height));
                imagePos.x = pos.x + (pos.width - newWidth) / 2;
                imagePos.width = newWidth;
            } else {
                var newHeight = Math.floor(height / (width / pos.width));
                imagePos.y = pos.y + (pos.height - newHeight) / 2;
                imagePos.height = newHeight;
            }

            image.x = imagePos.x;
            image.width = imagePos.width;
            image.y = imagePos.y;
            image.height = imagePos.height;
        }
    };

    el.setImagePosition = function (width, height, pos) {
        if (width / height > pos.width / pos.height) {
            var newWidth = parseInt(width / (height / pos.height), 10);
            pos.x = pos.x + (pos.width - newWidth) / 2;
            pos.width = newWidth;
        } else {
            var newHeight = parseInt(height / (width / pos.width), 10);
            pos.y = pos.y + (pos.height - newHeight) / 2;
            pos.height = newHeight;
        }

        return pos;
    };

    el.confirmDropType = function(workareaId, id, e) {
        e ? e.preventDefault() : false;

        if (lastName === '') {
            return;
        }

        el.dialog.show('confirm', {
            message: Yii.t('Add a photo to the background or to a new frame?'),
            cancelText: Yii.t('On the background'),
            cancelEvent: 'app.constructor.upImages.drop("backgrounds", ' + workareaId + ', ' + id + ')',
            continueText: Yii.t('In Frame'),
            continueEvent: 'app.constructor.cell.addWithImage()',
        });
    };

    el.drop = function (className, workareaId, id, e, cb) {
        if (lastName !== '') {
            e ? e.preventDefault() : false;

            $('.project-images .image').removeClass('selected');
            el.loader.show(Yii.t('Loading picture...'), false);

            var image = new Image();
            var url = window.location.origin + el.projectsPath + '/' + window.bookSid + '/workimages/' + lastName;

            if (el._parent.hasOwnProperty('isTemplater')) {
                url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/templates/' + window.bookSid + '/workimages/' + lastName;
            }

            image.onload = function () {
                el.setUsedImage(this.name);
                el.onloadImage(this, className, workareaId, id, this.name);
                el.workarea.render();
                el.preview.render();
                el.loader.hide();
                if (cb) {
                    cb();
                }
            };

            image.onerror = function () {
                el.loader.hide();
                alert(Yii.t('The selected image did not load'));
            };

            image.src = url;
            image.name = lastName;
            lastName = '';
        }
    };

    el.removeImage = function (filename) {
        if (el.canRemoveImage(filename)) {
            var data = {file: filename};

            el.request.delete(window.requestUrls.image.remove, data, function () {
                var files = [];
                for (var i in el.files) {
                    if (el.files[i].filename !== filename) {
                        files.push(el.files[i]);
                    }
                }

                el.files = files;
                el.render();
            }, 'json');
        } else {
            alert(Yii.t('The picture is used in the editor'));
        }
    };

    el.drag = function (e) {
        $('.project-images .image').removeClass('selected');
        $(e.target).parents('.image').addClass('selected');
        lastName = e.target.getAttribute('data-name');
    };

    el.allowDrop = function (e) {
        e.preventDefault();

        var $target = $(e.target);
        if ($target.hasClass('backgrounds-rect')) {
            $target.attr('fill-opacity', '0.5');
            return true;
        }

        var $element = $(e.target).parents('.grid-cell').find('.image-add');
        if ($element.length > 0) {
            $element.addClass('hover');
            return true;
        }
    };

    el.leaveDrag = function (e) {
        var $target = $(e.target);
        if ($target.hasClass('backgrounds-rect')) {
            $target.attr('fill-opacity', '0');
        }

        var $element = $(e.target).parents('.grid-cell').find('.image-add');
        if ($element.length > 0) {
            $element.removeClass('hover');
        }
    };

    el.setUsedImage = function (name) {
        var element = $('.project-images .image[data-name="' + name.split('.').join('\\.') + '"]');
        element.children('.image-used').removeClass('hide');

        if (usedImages.hasOwnProperty(name)) {
            usedImages[name]++;
        } else {
            usedImages[name] = 1;
        }
    };

    el.unsetUsedImage = function (name) {
        if (usedImages.hasOwnProperty(name)) {
            usedImages[name]--;

            if (usedImages[name] < 1) {
                delete usedImages[name];
                name = name.split('.').join('\\.');
                var element = $('.project-images .image[data-name="' + name + '"]');
                element.children('.image-used').addClass('hide');
            }
        }
    };

    el.reset = function () {
        usedImages = {};

        $('.project-images .image').children('.image-used').addClass('hide');
    };

    el.canRemoveImage = function (filename) {
        return !usedImages.hasOwnProperty(filename);
    };

    el.isUsedImages = function () {
        return Object.keys(usedImages).length !== 0;
    };

    el.show = function(e, className, id) {
        e.preventDefault();
        e.stopPropagation();

        destId = id;
        destClassName = className;

        el.dialog.hide('backgrounds');
        el.setDistribution(0);
        el.showContainer('upload-page');
    };

    el.setDistribution = function(value) {
        distribution = value;
    };

    el.autoDistribution = function() {
        if (!distribution) {
            return false;
        }

        if (newFiles.length === 0) {
            return false;
        }

        var currentIndex = 0;
        var workareas = el.workData.workareas;
        var format, file;
        for (var workareaId in workareas) {
            format = workareas[workareaId].format;
            for (var cellId in format.cells) {
                if (
                    format.hasOwnProperty('images')
                    && format.images.hasOwnProperty(cellId)
                    && format.images[cellId].type !== 'template'
                ) {
                    continue;
                }

                if (newFiles.length === currentIndex) {
                    continue;
                }

                file = el.files[newFiles[currentIndex]];

                lastName = file.filename;
                el.drop('images', workareaId, cellId);
                currentIndex++;
            }
        }

        newFiles = [];
        el.setDistribution(0);
        return true;
    };

    $(document).on('click', '.js-upimage-remove', function () {
        el.removeImage($(this).attr('data-filename'));
    });
    $(document).on('click dragstart', '.js-upimage-drag', el.drag);
    $(document).on('click', '.upload-show', function () {
        el.setDistribution(0);
        el.showContainer('upload-page');
    });

    $(document).on('click touchend', '.js-image-upload', function(e) {
        if (lastName === '') {
            el.show(e, $(this).attr('data-type'), $(this).attr('data-id'));
        }
    });

    $(window).resize(function() {
        reInitDimensions();
    });
};
